import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home';
import SignIn from '@/views/SignIn';
import SignUp from '@/views/SignUp';
import Dashboard from '@/views/Dashboard';
import PflegeleistungenAnalysis from '@/views/Pflegeleistungsfinder/Analysis';
import PflegeleistungenWizard from '@/views/Pflegeleistungsfinder/Wizard';
import ForgotPassword from '@/views/ForgotPassword';
import ResetPassword from '@/views/ResetPassword';
import CareLevelCalculatorIndex from '@/views/CareLevelCalculator/Index';
import CareLevelCalculatorPreWizard from '@/views/CareLevelCalculator/PreWizard';
import CareLevelCalculatorWizard from '@/views/CareLevelCalculator/Wizard';
import CareLevelCalculatorRegister from '@/views/CareLevelCalculator/Register';
import CareLevelCalculatorAnalysis from '@/views/CareLevelCalculator/Analysis';
import TaskScheduler from '@/views/TaskScheduler';
import Applications from '@/views/Applications';
import CareProfiles from '@/views/CareProfiles';
import Intro from '@/views/Intro';
import Profile from '../views/Profile';
import PrivacyStatement from '@/views/PrivacyStatement';
import Contact from '@/views/Contact';

import store from '@/store';

import redirects from './redirects';

import {
  ROUTE_HOME,
  ROUTE_LOGIN,
  ROUTE_REGISTER,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_RESET_PASSWORD,
  ROUTE_DASHBOARD,
  ROUTE_SERVICE_PFLEGELEISTUNGSFINDER,
  ROUTE_INTRO,
  ROUTE_SERVICE_CARELEVEL_CALCULATOR,
  ROUTE_SERVICE_CARELEVEL_CALCULATOR_PREWIZARD,
  ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD,
  ROUTE_SERVICE_CARELEVEL_CALCULATOR_REGISTER,
  ROUTE_TASK_SCHEDULER,
  ROUTE_ANALYSE_CARE_LEVEL,
  ROUTE_ANALYSE_CARE_SERVICE,
  ROUTE_APPLICATIONS,
  ROUTE_CARE_PROFILES,
  ROUTE_PROFILE,
  ROUTE_PRIVACY,
  ROUTE_CONTACT,
} from '@/constants/routes';

Vue.use(VueRouter);

/**
 * meta object:
 * requiresAuth (boolean): Only available in auth area
 * isDashboard (boolean): Inside dashboard wrapper with MainNav and MetaNav
 * hideMainNav (boolean): Disable MainNav
 * navBarHasShadow (boolean): Show NavBar shadow
 * hideNavBar (boolean): Disable NavBar
 * isDashboardWhenUserIsLoggedIn: (boolean): When a service exists inside and outside of dashboard. Eg. Pflegegradechner.
 */

const routes = [
  {
    path: ROUTE_HOME,
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: ROUTE_INTRO + '/:step?',
    name: 'Intro',
    component: Intro,
    meta: {
      requiresAuth: true,
      hideMainNav: true,
      isDashboard: true,
    },
  },
  {
    path: ROUTE_LOGIN + '/:token?',
    name: 'Login',
    component: SignIn,
    meta: {
      requiresAuth: false,
      navBarHasShadow: true,
    },
  },
  {
    path: ROUTE_REGISTER,
    name: 'Register',
    component: SignUp,
    meta: {
      requiresAuth: false,
      navBarHasShadow: true,
    },
  },
  {
    path: ROUTE_FORGOT_PASSWORD,
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      requiresAuth: false,
      navBarHasShadow: true,
    },
  },
  {
    path: ROUTE_RESET_PASSWORD + '/:token',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      requiresAuth: false,
      navBarHasShadow: true,
    },
  },
  {
    path: ROUTE_DASHBOARD,
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      isDashboard: true,
    },
  },
  {
    path: ROUTE_SERVICE_CARELEVEL_CALCULATOR,
    name: 'CareLevelCalculatorIndex',
    component: CareLevelCalculatorIndex,
  },
  {
    path: ROUTE_SERVICE_CARELEVEL_CALCULATOR_PREWIZARD + '/:step?',
    name: 'CareLevelCalculatorPreWizard',
    component: CareLevelCalculatorPreWizard,
  },
  {
    path: ROUTE_SERVICE_CARELEVEL_CALCULATOR_WIZARD + '/:step?',
    name: 'CareLevelCalculatorWizard',
    component: CareLevelCalculatorWizard,
    meta: {
      isDashboardWhenUserIsLoggedIn: true,
    },
  },
  {
    path: ROUTE_SERVICE_CARELEVEL_CALCULATOR_REGISTER,
    name: 'CareLevelCalculatorRegister',
    component: CareLevelCalculatorRegister,
  },
  {
    path: ROUTE_ANALYSE_CARE_LEVEL + '/:token?',
    name: 'CareLevelCalculatorAnalysis',
    component: CareLevelCalculatorAnalysis,
    meta: {
      isDashboardWhenUserIsLoggedIn: true,
    },
  },
  {
    path: ROUTE_TASK_SCHEDULER,
    name: 'TaskScheduler',
    component: TaskScheduler,
    meta: {
      requiresAuth: true,
      isDashboard: true,
    },
  },
  {
    path: ROUTE_ANALYSE_CARE_SERVICE,
    name: 'PflegeleistungenAnalysis',
    component: PflegeleistungenAnalysis,
    meta: {
      requiresAuth: true,
      isDashboard: true,
    },
  },
  {
    path: ROUTE_SERVICE_PFLEGELEISTUNGSFINDER + '/:step?',
    name: 'PflegeleistungenWizard',
    component: PflegeleistungenWizard,
    meta: {
      requiresAuth: true,
      isDashboard: true,
    },
  },
  {
    path: ROUTE_APPLICATIONS,
    name: 'Applications',
    component: Applications,
    meta: {
      requiresAuth: true,
      isDashboard: true,
    },
  },
  {
    path: ROUTE_CARE_PROFILES,
    name: 'CareProfiles',
    component: CareProfiles,
    meta: {
      requiresAuth: true,
      isDashboard: true,
    },
  },
  {
    path: ROUTE_PROFILE,
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      isDashboard: true,
    },
  },
  {
    path: ROUTE_PRIVACY,
    name: 'Privacy',
    component: PrivacyStatement,
    meta: {
      requiresAuth: false,
      isDashboard: false,
      hideNavBar: false,
      hideMainNav: true,
    },
  },
  {
    path: ROUTE_CONTACT,
    name: 'Contact',
    component: Contact,
    meta: {
      requiresAuth: false,
      isDashboard: false,
      hideNavBar: false,
      hideMainNav: true,
    },
  },
  ...redirects,

  {
    path: '*',
    name: '404',
    component: Home,
    meta: {
      requiresAuth: false,
      status: '404',
    },
  },
];

if (process.env.NODE_ENV === 'development') {
  routes.push({
    path: '/testing',
    name: 'Testing',
    component: () => import('../views/Testing'),
  });
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.isDashboardWhenUserIsLoggedIn) {
    to.meta.isDashboard = store.state.auth.isAuthenticated;
  }

  if (to.meta.requiresAuth && !store.state.auth.isAuthenticated) {
    next({
      path: ROUTE_LOGIN,
    });
  } else {
    next();
  }
});

export default router;
